module.exports = {"TXTCLI_Apply__forChanges":{"id":"TXTCLI_Apply__forChanges","defaultMessage":"Anvend","flags":["TRACK"],"track":"Apply"}}